class GlobalSites extends HTMLElement {
  static properties = {
    _state: {
      type: Number,
      state: true,
    }
  }

  constructor() {
    super()

    this.toTop = this.querySelector('.js-go-to-top')
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this)
    this.goToTopHandler = this.goToTop.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.toTop.addEventListener('click', this.goToTopHandler)
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
    this.toTop.removeEventListener('click', this.goToTopHandler)
  }

  goToTop() {
    window.scrollTo({
      top: 0,
      left: 0
    })
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const pastHeight = this.offsetTop + this.offsetHeight - window.innerHeight

    if (
      scrollTop > this.offsetTop &&
      scrollTop <= pastHeight
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (
      scrollTop > this.offsetTop &&
      scrollTop > pastHeight
    ) {
      requestAnimationFrame(this.toBottom.bind(this))
    } else if (scrollTop < this.offsetTop - 50) {
      requestAnimationFrame(this.reset.bind(this))
    } else {
      requestAnimationFrame(this.resetBefore.bind(this))
    }

    if (this._state === 2) {
      this.classList.remove('sticky-bar--has-reset')
      this.classList.add('sticky-bar--has-scrolled')
      this.classList.add('sticky-bar--in-bottom')
    } else if (this._state === 1) {
      this.classList.remove('sticky-bar--has-reset')
      this.classList.add('sticky-bar--has-scrolled')
      this.classList.remove('sticky-bar--in-bottom')
    } else if (this._state === 0) {
      this.classList.remove('sticky-bar--has-reset')
      this.classList.remove('sticky-bar--has-scrolled')
      this.classList.remove('sticky-bar--in-bottom')
    } else if (this._state === 3) {
      this.classList.remove('sticky-bar--has-scrolled')
      this.classList.remove('sticky-bar--in-bottom')
      this.classList.add('sticky-bar--has-reset')
    }
  }

  reveal() {
    if (this._state === 1) {
      return
    }
    this._state = 1
  }

  toBottom() {
    if (this._state === 2) {
      return
    }
    this._state = 2
  }

  resetBefore() {
    if (this._state === 0 || this._state === 3) {
      return
    }
    this._state = 3
  }

  reset() {
    if (this._state === 0) {
      return
    }
    this._state = 0
  }
}

customElements.define('global-sites', GlobalSites)
